import { Grid } from "@mui/material";
import type { DateValidationError } from "@mui/x-date-pickers-pro";
import { useState } from "react";
import BcDatePicker from "@entrilia/shared/components/reporting/bc-datepicker/BcDatePicker";
import { formatToISODate, getValidatedDate } from "../../../../reporting/utils/dateUtils";

interface Props {
  filterValue: string; //e.g. "9/25/2025"
  onUpdateFilter: (filterValue: string, isValid: boolean) => void;
}

const WorkbookFilterItemDateInput = ({ filterValue, onUpdateFilter }: Props) => {
  const [value, setValue] = useState<Date | null>(() => {
    const date = getValidatedDate(filterValue);
    return !date || isNaN(date.getTime()) ? null : date;
  });

  const handleValueChange = (newValue: Date | null, validationError: DateValidationError | null) => {
    setValue(newValue);
    const isValid = newValue !== null && validationError === null;
    const formattedValue = isValid && newValue ? formatToISODate(newValue) : "";
    onUpdateFilter(formattedValue, isValid);
  };

  return (
    <Grid container sx={{ width: "100%" }}>
      <BcDatePicker value={value} onChange={handleValueChange} />
    </Grid>
  );
};

export default WorkbookFilterItemDateInput;
